<template>
  <dialog-v2
    :show="show"
    title="Probar plantilla"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-model="form.to"
            v-validate="`${toRules}`"
            data-vv-name="to"
            :data-vv-as="toLabel"
            :data-vv-scope="validationScope"
            :error-messages="errors.collect(`${validationScope}.to`)"
            :label="toLabel"
            color="black">
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md6 pr-4>
          <v-text-field
            v-model="form.first_name"
            v-validate="'required'"
            data-vv-name="first_name"
            data-vv-as="nombre"
            :data-vv-scope="validationScope"
            :error-messages="errors.collect(`${validationScope}.first_name`)"
            label="Nombre"
            color="black">
          </v-text-field>
        </v-flex>
        <v-flex md6>
          <v-text-field
            v-model="form.last_name"
            v-validate="'required'"
            data-vv-name="last_name"
            data-vv-as="apellido"
            :data-vv-scope="validationScope"
            :error-messages="errors.collect(`${validationScope}.last_name`)"
            label="Apellido"
            color="black">
          </v-text-field>
        </v-flex>
        </v-layout>
        <v-layout row wrap>
        <v-flex md6 pr-3>
          <v-text-field
            v-model="form.amount"
            v-validate="'required|numeric'"
            data-vv-name="amount"
            data-vv-as="monto"
            :data-vv-scope="validationScope"
            :error-messages="errors.collect(`${validationScope}.amount`)"
            label="Monto"
            color="black">
          </v-text-field>
        </v-flex>
        <v-flex md6>
          <v-menu
            ref="testPicker"
            :nudge-right="40"
            :return-value.sync="form.due_date"
            :close-on-content-click="false"
            transition="scale-transition"
            max-width="290px"
            lazy
            offset-y
            full-width
            min-width="290px">
            <v-text-field
              slot="activator"
              v-model="form.due_date"
              v-validate="'required'"
              data-vv-name="due_date"
              data-vv-as="fecha de vencimiento"
              :data-vv-scope="validationScope"
              :error-messages="errors.collect(`${validationScope}.due_date`)"
              label="Vencimiento"
              prepend-icon="event"
              class="k-orange-linear-text"
              readonly>
            </v-text-field>
            <v-date-picker
              v-model="form.due_date"
              @input="$refs.testPicker.save(form.due_date)"
              locale="es"
              color="k-orange-linear"
              scrollable>
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';
import { setTimeout } from 'timers';
import moment from 'moment';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    templateId: {
      type: Number,
      required: true,
    },
    channel: {
      type: Number,
      required: true,
    },
    validationScope: {
      type: String,
      default: 'testTemplate',
    },
  },
  components: {
    DialogV2,
  },
  data() {
    return {
      form: {
        to: '',
        first_name: this.$auth.user().first_name,
        last_name: this.$auth.user().last_name,
        due_date: moment().format('YYYY-MM-DD'),
        amount: 150000,
      },
    };
  },
  computed: {
    toLabel() {
      let label = '';
      if (this.channel === 1) {
        label = 'Email';
      } else {
        label = 'Teléfono';
      }
      return label;
    },
    toRules() {
      let rules = 'required|';
      if (this.channel === 1) {
        rules += 'email';
      } else {
        rules += 'numeric';
      }
      return rules;
    },
  },
  methods: {
    save() {
      this.$validator.validateAll(this.validationScope).then((validation) => {
        if (validation) {
          this.axios.post('v2/templates/test', {
            ...this.form,
            template_id: this.templateId,
            channel_id: this.channel,
          }).then(() => {
            this.$emit('close');
          }).catch(() => {});
        }
      });
    },
  },
  watch: {
    show() {
      if (!this.show) {
        setTimeout(() => {
          this.form = {
            to: '',
            first_name: this.$auth.user().first_name,
            last_name: this.$auth.user().last_name,
            due_date: moment().format('YYYY-MM-DD'),
            amount: 150000,
          };
          Object.keys(this.form).forEach((key) => {
            this.$validator.errors.remove(key, this.validationScope);
          });
        }, 200);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Templates/TestDialog.vue